export default {
  SET_CLIENTS: function (state, payloads) {
    state.clients = payloads;
  }
}
